import { createContext, useContext, useEffect, useState } from 'react'

interface FirstVisitContextType {
  isFirstVisit: boolean
}

const FirstVisitContext = createContext<FirstVisitContextType>({
  isFirstVisit: true,
})

export const FirstVisitProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const isFirstVisitInStorage = typeof window !== 'undefined' && localStorage.getItem('isFirstVisit') === null
  const [isFirstVisit, setIsFirstVisit] = useState<boolean>(isFirstVisitInStorage)

  useEffect(() => {
    const listener = () => {
      setIsFirstVisit(false)
      sessionStorage.setItem('isFirstVisit', 'false')
    }

    window.addEventListener('visibilitychange', listener)
    return () => {
      window.removeEventListener('visibilitychange', listener)
    }
  }, [])

  return <FirstVisitContext.Provider value={{ isFirstVisit }}>{children}</FirstVisitContext.Provider>
}

export function useFirstVisit() {
  const context = useContext(FirstVisitContext)
  if (context === undefined) {
    throw new Error('useFirstVisit must be used within a FirstVisitProvider')
  }
  return context.isFirstVisit
}
